var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMinusGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 3,
    viewBox: "0 0 13 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#343A40",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.414 20.35c.417 0 .773-.348.773-.779 0-.424-.356-.779-.773-.779h-9.898c-.404 0-.773.355-.773.78 0 .43.37.779.773.779h9.898z",
    transform: "translate(-244 -340) translate(16 167) translate(0 10) translate(214 145)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMinusGray);
export default __webpack_public_path__ + "static/media/ic_minus_gray.47cea4817fa7d8ffea29ea225bd71754.svg";
export { ForwardRef as ReactComponent };